/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomPaginationV2.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { Box, Pagination, PaginationItem } from "@mui/material";
import React from "react";
import { componentStyle } from "../../../../config/appTheme";

function CustomPaginationV2({
  page,
  rowsPerPage,
  onPageChange,
  totalItems,
  size = "default",
}) {
  const count = Math.ceil(totalItems / rowsPerPage);
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
        width: "100%",
      }}
    >
      <Pagination
        count={count}
        page={page}
        onChange={(event, page) => {
          onPageChange(page);
        }}
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{ previous: () => "Previous", next: () => "Next" }}
          />
        )}
        sx={{
          "& .MuiPaginationItem-root": {
            color: "black",
            borderRadius: "0px",
            transition: "all 0.2s ease",
            minWidth: "32px",
            whiteSpace: "nowrap",
            ...(size === "small" && { ...componentStyle.font.text }),
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#e0e0e0",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "black",
            color: "white",
          },
          "& .MuiPaginationItem-root.Mui-selected:hover": {
            backgroundColor: "black",
          },
        }}
      />
    </Box>
  );
}

export default CustomPaginationV2;
